export enum PROJECT_NAME {
  VISA_GCC = 'visaGcc',
  VISA_SSA = 'visaSsa',
  VISA_FOREX = 'visaForex',
  VISA_HAJJ = 'visaHajj',
}
